
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInItemsSelectGrid extends _Ext.GridBase<BranchInItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchInItemsSelect'; }
        protected getDialogType() { return <any>BranchInItemsDialog; }
        protected getIdProperty() { return BranchInItemsRow.idProperty; }
        protected getLocalTextPrefix() { return BranchInItemsRow.localTextPrefix; }
        protected getService() { return BranchInSelectItemsService.baseUrl; }
        protected getInitialTitle() { return null; };
    
        constructor(container: JQuery, options) {
            super(container, options); 
            var partyid = options.GridFilters.PartyId;
            if (partyid != null && partyid > 0)
                (this.view.params as TransactionRequest).PartyId = partyid;

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        private autoSize; 
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        get selectedItems(): BranchInItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }
        protected usePager() { return false; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };
        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            return true;
        }
    } 
}